<template>
  <div class="clearfix">
    <div class="vx-row">
      <div class="vx-col md:w-full sm:w-full lg:w-1/3">
        <vs-input
          v-validate="'required|min:3'"
          data-vv-validate-on="blur"
          label-placeholder="Name"
          name="displayName"
          placeholder="Name"
          v-model="displayName"
          class="w-full mt-8" />
        <span class="text-danger text-sm">{{ errors.first('displayName') }}</span>

        <vs-input
          v-validate="'required|email'"
          data-vv-validate-on="blur"
          name="email"
          type="email"
          label-placeholder="Email"
          placeholder="Email"
          v-model="email"
          class="w-full mt-8" />
        <span class="text-danger text-sm">{{ errors.first('email') }}</span>

        <vs-input
          v-validate="'required|min:3'"
          data-vv-validate-on="blur"
          label-placeholder="Company Name"
          name="companyName"
          placeholder="Company Name"
          v-model="companyName"
          class="w-full mt-8" />
        <span class="text-danger text-sm">{{ errors.first('companyName') }}</span>

        <vs-input
          v-validate="'required|numeric'"
          data-vv-validate-on="blur"
          name="phone"
          type="phone"
          label-placeholder="Phone Number"
          placeholder="Phone Number"
          v-model="phone"
          class="w-full mt-8" />
        <span class="text-danger text-sm">{{ errors.first('phone') }}</span>

        <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">I accept the terms & conditions.</vs-checkbox>
        <vs-button class="float-right mt-8" @click="updateUser" :disabled="!validateForm">Update information</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
// import firebase from "firebase";
const firebaseActions = require('@/firebase/firebaseActions.js');

export default {
  data () {
    return {
      displayName: '',
      email: '',
      companyName: '',
      phone: '',
      isTermsConditionAccepted: true,
      stripe_id: ''
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.displayName !== '' && this.email !== '' && this.companyName !== '' && this.phone !== '' && this.password !== '' && this.confirm_password !== '' && this.isTermsConditionAccepted === true
    }
  },
  mounted() {
    this.displayName = this.$store.state.AppActiveUser.displayName,
    this.email = this.$store.state.AppActiveUser.email,
    this.companyName = this.$store.state.AppActiveUser.companyName,
    this.phone = this.$store.state.AppActiveUser.phone,
    this.stripe_id = this.$store.state.AppActiveUser.stripe_id
  },
  methods: {

    async updateUser () {
      // If form is not validated or user is already login return
      if (!this.validateForm) {

        this.$vs.notify({
          title: 'User information update attempt',
          text: 'The form data is incorrect or incomplete!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      const payload = {
        userDetails: {
          displayName: this.displayName,
          email: this.email,
          companyName: this.companyName,
          phone: this.phone,
          stripe_id: this.stripe_id
        },
        notify: this.$vs.notify
      }

      this.$vs.loading()
      this.$store.commit('UPDATE_USER_INFO', payload.userDetails, {root: true})
      await firebaseActions.addCustomerToFirebase(payload.userDetails)
        .then(() => {
          //console.log('customer information updated to firebase.');
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'User information update',
            text: 'Customer information updated!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        })
        .catch(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'User information update attempt',
            text: 'Something went wrong while updating customer information! Please try again.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

          return false
        })
    }
  }
}
</script>
